module.exports = __webpack_public_path__ + "static/media/IP_Enrollment_Portal.22345313.png";